module.exports = __webpack_public_path__ + "img/markerFerryBlue.a36753db.svg";